(function(d) {

  const openModalBtns = d.querySelectorAll('wdn-modal-open[data-id="featured-product-videos"]');
  const modal = d.querySelector('#featured-product-videos');
  let loadedVideos;
  let hasLoadedVideos;

  if (!openModalBtns || !modal) return;

  const activateVideo = (videos, handle) => {
    videos.forEach(video => {
      if (video.classList.contains('active-video')) {
        video.classList.remove('active-video');
      }
      
      if (handle === video.dataset.featuredProductVideo) {
        video.classList.add('active-video');
        video.play();
        return;
      }
    });
  }

  const fetchVideos = (handle) => {
    fetch(Shopify.routes.root + location.pathname.replace('/','') + "?section_id=async-featured-product-videos")
    .then((res) => res.text())
    .then((resText) => {
      var domParser = new DOMParser();
      var sectionContent = domParser.parseFromString(resText, "text/html");

      modal.querySelector('.featured-product-video__videos').innerHTML = sectionContent.querySelector('#shopify-section-async-featured-product-videos').innerHTML;
      loadedVideos = modal.querySelectorAll('video');
      activateVideo(loadedVideos, handle);
    });
  }
  
  openModalBtns.forEach(btn => {
    let handle = btn.dataset.featuredVideoHandle;
    btn.addEventListener('click', () => {
      
      if (!hasLoadedVideos) {
        fetchVideos(handle);
        hasLoadedVideos = true;
        return;
      }
  
      activateVideo(loadedVideos, handle);
    });
  });

  modal.addEventListener('click', (e) => {
    if (e.target === document.body 
        || (e.target === modal && e.target.nodeName === "WDN-MODAL") 
        || e.target.nodeName === "WDN-MODAL-CLOSE" 
        || e.target.closest("WDN-MODAL-CLOSE")
       ) {
      if (loadedVideos) {
        loadedVideos.forEach(video => {
          if (video.classList.contains('active-video')) {
            video.pause();
            video.classList.remove('active-video');
          }
        });
      }
    }
  });
})(document);